import { Alert } from "antd"
import React from "react"
import { useTranslation } from "react-i18next"

import { type LeadMissingField } from "./lead-missing-fields.ts"

interface LeadMissingFieldsNoticeProps {
  fields: LeadMissingField[]
  testId?: string
}

/** The card-level counterpart of the old form's per-input stage mark. */
function LeadMissingFieldsNotice({
  fields,
  testId = "lead-missing-fields"
}: LeadMissingFieldsNoticeProps) {
  const { t } = useTranslation()

  if (!fields.length) return null

  const labels = fields.map((field) =>
    t(field.labelKey, { defaultValue: field.field })
  )

  return (
    <Alert
      type={"error"}
      showIcon
      role={"alert"}
      data-testid={testId}
      message={t("leadWorkspace.missing.card", { fields: labels.join(", ") })}
    />
  )
}

export { LeadMissingFieldsNotice }
